module.exports = __webpack_public_path__ + "img/banner-loading-2.75e6a1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/front/assets/images/project/loader/banner-loading-2.jpg
// module id = 51ow
// module chunks = 9